import { useEffect, useState } from "react";

import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import DwellingServicesDataGridComponent from "./DwellingServicesDataGridComponent";
import DwellingInfo from "./sheet/DwellingInfo";
import { displayFullName } from "../../../_helpers/stringHelper";
import edit from "../../../assets/svg/edit.svg";
import Loader from "../../../common/components/Loader";
import history from "../../../routes/history";
import { ITenant } from "../../serviceOrdering/reducers";
import { PropsFromReduxDwellingSheetDetails } from "../containers/DwellingSheetDetailsContainer";
import { DWELLINGS, UPDATE_DWELLING } from "../routes";

const defaultPropertySheet = {
  dpe: {
    value: "C",
    date: new Date(),
  },
  ges: {
    done: true,
    level: "B",
    expiration: new Date(),
  },
};

interface RouteParams {
  id: string;
}

export const getLastTenant = (tenants?: ITenant[]) => {
  const tenant = tenants && tenants[tenants.length - 1];
  return displayFullName(tenant?.person?.lastname, tenant?.person?.firstname);
};

export const getLastTenantEmail = (tenants?: ITenant[]) => {
  const tenant = tenants && tenants[tenants.length - 1];
  return tenant?.person?.email;
};

const DwellingSheetDetails = ({
  dwelling,
  getDwelling,
  getDwellingServices,
  dwellingServices,
  dwellingServicesCount,
  getDwellingServicesInventory,
}: PropsFromReduxDwellingSheetDetails) => {
  const { id } = useParams<RouteParams>();
  const [loading, setLoading] = useState(true);
  const [serviceGridActivePage, setServiceGridActivePage] = useState(1);
  const [inventoryGridActivePage, setInventoryGridActivePage] = useState(1);
  const [loadingInventories, setLoadingInventories] = useState(true);
  const [loadingServices, setLoadingServices] = useState(true);

  useEffect(() => {
    getDwelling(id)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        toast.error("Aucun bien correspondant");
        history.push(DWELLINGS);
      });
  }, []); //eslint-disable-line

  useEffect(() => {
    setLoadingServices(true);
    getDwellingServices(serviceGridActivePage, id).finally(() =>
      setLoadingServices(false)
    );
  }, [serviceGridActivePage]); //eslint-disable-line

  useEffect(() => {
    setLoadingInventories(true);
    getDwellingServicesInventory(inventoryGridActivePage, id).finally(() =>
      setLoadingInventories(false)
    );
  }, [inventoryGridActivePage]); //eslint-disable-line

  return loading ? (
    <div className="p-3 p-lg-4">
      <div className="bg-white rounded-4 p-3 p-lg-5 mt-4">
        <Loader />
      </div>
    </div>
  ) : (
    <>
      <div className="p-3 p-lg-4">
        <DwellingInfo
          dwelling={dwelling}
          dpe={defaultPropertySheet.dpe}
          ges={defaultPropertySheet.ges}
        />

        <div className="bg-white rounded-4 p-3 p-lg-5 mt-4">
          <div className="propertySheetDetailsPartTitle mb-3 d-flex flex-wrap justify-content-between">
            <p>Caractéristiques du bien</p>
            <div className="d-flex flex-row justify-content-between gap-2">
              <Link
                to={UPDATE_DWELLING.replace(
                  ":id",
                  dwelling.datedReference || dwelling.id || ""
                ).replace(":isAssociatingBuilding", "true")}
                className="d-flex align-items-center btn btn-success"
                style={{ height: "36px" }}
              >
                <p
                  className="m-0 me-2"
                  style={{ fontSize: "20px", lineHeight: "9px" }}
                >
                  +
                </p>
                Associer à un immeuble existant
              </Link>
              <Link
                to={UPDATE_DWELLING.replace(
                  ":id",
                  dwelling.datedReference || dwelling.id || ""
                ).replace(":isAssociatingBuilding", "false")}
                className="btn btn-actions btn-edit-order"
                style={{ height: "36px", width: "36px" }}
              >
                <img
                  src={edit}
                  alt="edit"
                  style={{ width: "12px", height: "12px" }}
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-4 p-3 p-lg-5 mt-4">
          <div className="propertySheetDetailsPartTitle mb-2 d-flex flex-wrap justify-content-between">
            <p>Historiques des interventions</p>
          </div>
          <Row>
            <Col>
              <DwellingServicesDataGridComponent
                services={dwellingServices}
                activePage={serviceGridActivePage}
                setActivePage={setServiceGridActivePage}
                servicesNb={dwellingServicesCount}
                loading={loadingServices}
              />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default DwellingSheetDetails;
